module.exports = __webpack_public_path__ + "img/pawpaw-350x184.8dbdda50.jpg";